import { instance } from '@shared/api/config';
import { path } from '../../config';

// Отчёт для взыскания: дёргает эндпоинт oci-docs /api/report/collection/{osiId}
// (через прокси /doc/api/report/collection/{osiId}).
// Поддерживает сворачивание дочерних помещений (паркинги/кладовки влиты в родителя) — как у должников.
export const getCollectionByOsiId = (
  osiId: number,
  period: {
    begin: any;
    end: any;
  },
  // Флаг «Свернуть дочерние помещения»: при true дописываем query-параметр для бэкенда oci-docs
  collapseChildren = false
): Promise<any> =>
  instance.get(
    `${path}/collection/${osiId}?begin=${period.begin}&end=${period.end}${
      collapseChildren ? '&collapseChildren=true' : ''
    }`
  );
